import { MsalProvider } from "@azure/msal-react";
import React, { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import { Spinner } from "./components/shared/Spinner";
import { AppRoutes } from "./routes";

function App({ pca }: any): React.ReactElement {
  return (
    <BrowserRouter>
      <MsalProvider instance={pca}>
        <Suspense fallback={<Spinner />}>
          <AppRoutes />
        </Suspense>
      </MsalProvider>
    </BrowserRouter>
  );
}

export default App;
